/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, Status, cleanObject, ajax, toQueryString, } from '../twd/twd'

const Last = getState('order-ticket-account-info.last', {
    ts: 0,
    accountInfo: {},
    hasAccountInfo: false,
    accountInfoStatus: Status.NULL,
})

export const resetLastAccountInfo = ({ts=0} = {}) => {
    Last.reset()
    Last.set({
        ts,
        accountInfo: {},
        hasAccountInfo: false,
        accountInfoStatus: Status.NULL,
    })
}

export default ({acctNo, ts}) => {

    const [accountInfo, setAccountInfo_] = React.useState(Last.value.orderInfo || {})
    const setAccountInfo = React.useCallback((accountInfo_) => {
        accountInfo_ = accountInfo_ || {}
        let x = Number.parseFloat(accountInfo_.BuyingPower)
        accountInfo_.purchasingPower = isNaN(x) ? (accountInfo_.purchasingPower || null) : x

        Last.set({accountInfo:accountInfo_})
        setAccountInfo_(accountInfo_)
    }, [])

    const [hasAccountInfo, setHasAccountInfo_] = React.useState(Last.value.hasOrderInfo || false)
    const setHasAccountInfo = React.useCallback((hasAccountInfo_) => {
        Last.set({hasAccountInfo: hasAccountInfo_})
        setHasAccountInfo_(hasAccountInfo_)
    }, [])

    const [accountInfoStatus, setAccountInfoStatus_] = React.useState(Last.value.orderInfoStatus || Status.NULL)
    const setAccountInfoStatus = React.useCallback((accountInfoStatus_) => {
        Last.set({accountInfoStatus: accountInfoStatus_})
        setAccountInfoStatus_(accountInfoStatus_)
    }, [])

    const reset = () => {
        Last.reset()
        setHasAccountInfo(false)
        setAccountInfo({})
        setAccountInfoStatus(Status.NULL)
    }

    React.useEffect(() => {(async () => {
        if (!ts) return

        try {
            setHasAccountInfo(false)

            if (!acctNo) {
                setAccountInfoStatus(Status.NULL)
                return
            }

            setAccountInfoStatus(Status.LOADING)

            const params = cleanObject({
                acctId: acctNo.replace('-', ''),
            })

            const { data:acct_ } = await ajax({
                url: '/esb/portfolio/trades/accountInfo',
                method: 'POST',
                headers_: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: toQueryString(params),
            })


            const info = await acct_
            setAccountInfo(info)
            setHasAccountInfo(true)
            setAccountInfoStatus(Status.LOADED)

        } catch(e) {
            setAccountInfo({})
            setHasAccountInfo(false)
            setAccountInfoStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [acctNo, ts])


    return {
        accountInfo,
        setAccountInfo,
        hasAccountInfo,
        setHasAccountInfo,
        accountInfoStatus,
        setAccountInfoStatus,
        reset,
    }

}
